import { writable, derived } from "svelte/store";
import type { TrackingLabels } from "../tracking/TrackingLabels";

const trackingLabelsStore = writable<Partial<TrackingLabels>>({});

export function setTrackingLabel<T extends keyof TrackingLabels>(label: T, value: TrackingLabels[T]) {
  trackingLabelsStore.update((current) => ({
    ...current,
    [label]: value,
  }));
}

export const sanPopularFacetValues = derived(
  trackingLabelsStore,
  ($labels) => $labels.san_PopularFacetValues ?? "none",
);

export const sanFilterWhatIf = derived(trackingLabelsStore, ($labels) => $labels.san_FilterWhatIf);
